"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-dislike.tsx
var Dislike = function Dislike(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_6340_5952)"
  }, (0, _preact.h)("path", {
    d: "M14.6667 2.66699H13.3334C12.9667 2.66699 12.6667 2.96699 12.6667 3.33366L12.6667 9.33366C12.6667 9.70033 12.9667 10.0003 13.3334 10.0003H14.6667L14.6667 2.66699ZM1.44675 7.41366C1.37341 7.58033 1.33341 7.76033 1.33341 7.94699V8.66699C1.33341 9.40033 1.93341 10.0003 2.66675 10.0003L6.33341 10.0003L5.72008 13.1003C5.68675 13.247 5.70675 13.407 5.77341 13.5403C5.92675 13.8403 6.12008 14.1137 6.36008 14.3537L6.66675 14.667L10.9401 10.3937C11.1934 10.1403 11.3334 9.80033 11.3334 9.44699L11.3334 4.22033C11.3334 3.36699 10.6334 2.66699 9.77341 2.66699L4.36675 2.66699C3.90008 2.66699 3.46008 2.91366 3.22008 3.31366L1.44675 7.41366Z",
    fill: "currentColor"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_6340_5952"
  }, (0, _preact.h)("rect", {
    width: "16",
    height: "16",
    fill: "white",
    transform: "matrix(-1 0 0 -1 16 16)"
  }))));
};

var _default = Dislike;
exports.default = _default;